import React, { useState } from 'react';
import { useMotionMode } from '../contexts/MotionContext';
import { HeroCurtain } from '../components/motion/HeroCurtain';
import { HomeHero } from '../components/home/HomeHero';
import { StatsBar } from '../components/home/StatsBar';
import { BrandLogos } from '../components/home/BrandLogos';
import { ServicesGrid } from '../components/home/ServicesGrid';
import { JourneyMap } from '../components/home/JourneyMap';
import { FleetShowcase } from '../components/home/FleetShowcase';
import { GoogleReviews } from '../components/home/GoogleReviews';
import { HomeCta } from '../components/home/HomeCta';

const CURTAIN_KEY = 'oc-curtain-seen';

const Home = () => {
  const { cinematic } = useMotionMode();
  const [curtain, setCurtain] = useState(() => cinematic && !sessionStorage.getItem(CURTAIN_KEY));
  const done = () => { sessionStorage.setItem(CURTAIN_KEY, '1'); setCurtain(false); };

  return (
    <div className="min-h-screen bg-white text-gray-900" data-testid="home-page">
      {curtain && <HeroCurtain onDone={done} />}
      <HomeHero introDelay={curtain ? 1.9 : 0} />
      <StatsBar />
      <BrandLogos />
      <ServicesGrid />
      <JourneyMap />
      <FleetShowcase />
      <GoogleReviews />
      <HomeCta />
    </div>
  );
};

export default Home;
